export function getModelValue(modelSetting) {
  const value = typeof modelSetting === 'object' && modelSetting !== null
    ? modelSetting.value
    : modelSetting;
  return typeof value === 'string' ? value.trim() : '';
}

export function isCompleteUserSettings(settings) {
  if (!settings || typeof settings !== 'object' || Array.isArray(settings)) {
    return false;
  }

  const requiredTextFields = ['task', 'subjectField', 'providedMaterials'];
  if (!getModelValue(settings.model)) {
    return false;
  }
  if (requiredTextFields.some((field) => typeof settings[field] !== 'string' || !settings[field].trim())) {
    return false;
  }

  const minBytes = Number(settings.minBytes);
  const maxBytes = Number(settings.maxBytes);
  return (
    settings.minBytes !== '' &&
    settings.minBytes !== null &&
    settings.maxBytes !== '' &&
    settings.maxBytes !== null &&
    Number.isFinite(minBytes) &&
    Number.isFinite(maxBytes) &&
    minBytes >= 0 &&
    maxBytes >= minBytes &&
    maxBytes <= 3000
  );
}

export function isSolarModel(modelSetting) {
  const modelValue = getModelValue(modelSetting);
  return Boolean(modelValue && modelValue.includes('solar'));
}

export function toCreditUnits(value) {
  return Math.round(Number(value || 0) * 100);
}

// Upstage 프로모션: solar 모델은 이 시점(KST)까지 무료(0크레딧), 이후 0.2크레딧
export const SOLAR_FREE_UNTIL = new Date('2027-01-31T23:59:59+09:00');

export function isSolarFreePromoActive(now = new Date()) {
  return now <= SOLAR_FREE_UNTIL;
}

export function getCreditCostUnits(modelSetting) {
  if (isSolarModel(modelSetting)) {
    return isSolarFreePromoActive() ? 0 : 20;
  }
  return 100;
}

export function resolveSeedValue(userSettings) {
  if (isSolarModel(userSettings?.model)) {
    return 0;
  }

  if (userSettings?.openAIParameters?.randomSeed) {
    return crypto.getRandomValues(new Uint32Array(1))[0];
  }

  return userSettings?.openAIParameters?.seed ?? 0;
}

export function applyForbiddenWordReplacements(text, forbiddenWords = []) {
  return forbiddenWords.reduce((result, word) => {
    if (!word?.before) {
      return result;
    }

    return result.replace(new RegExp(word.before, 'gu'), word.after ?? '');
  }, text);
}

export function getGenerateSpecialNoteUrl(isASGS) {
  return isASGS
    ? 'https://asia-northeast1-studentremark-helper.cloudfunctions.net/generateSpecialNoteForASGS'
    : 'https://asia-northeast1-studentremark-helper.cloudfunctions.net/generateSpecialNote';
}

export function getAdjustTokenUrl(isASGS) {
  return isASGS
    ? 'https://asia-northeast1-studentremark-helper.cloudfunctions.net/adjustTokenSpecialNoteForASGS'
    : 'https://asia-northeast1-studentremark-helper.cloudfunctions.net/adjustTokenSpecialNote';
}
